// @ts-nocheck
import {ref, Ref} from "vue"

const $user: Ref<any | null> = ref(null)

export default $user